var map = {
	"./baby.png": 4212,
	"./blush-face.png": 1328,
	"./colgate-amazon.png": 7395,
	"./fin-upp-logo.png": 5781,
	"./fonts/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4iFU0U1Z4Y.woff2": 7500,
	"./fonts/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4iFV0U1.woff2": 9745,
	"./fonts/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4iFVUU1Z4Y.woff2": 2681,
	"./fonts/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4iFWUU1Z4Y.woff2": 8646,
	"./fonts/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4iFWkU1Z4Y.woff2": 1944,
	"./gillette-amazon.png": 4958,
	"./linkedin-icon.png": 655,
	"./logo.png": 6949,
	"./rise-up-logo.svg": 7038,
	"./share-icon.png": 8610,
	"./tutorial-background.jpg": 8782,
	"./woman-razor-amazon.png": 8023,
	"./wrapped-gift.png": 3683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;